import { Outlet } from 'react-router-dom';
import LinkTabs from '../../../shared/components/LinkTabs/LinkTabs';
import BlacklistHeader from './BlacklistHeader/BlacklistHeader';
import { BlacklistManagementProvider } from '../context/BlacklistManagement';
import { useTranslations } from 'use-intl';

export const getBlacklistTabs = (
  t: ReturnType<typeof useTranslations<'blacklistManagement.tabs'>>
) => [
  {
    label: t('channelWise'),
    path: '/settings/blacklist',
  },
  {
    label: t('loyaltySms'),
    path: '/settings/blacklist/loyalty',
  },
  {
    label: t('webhookManager'),
    path: '/settings/blacklist/webhooks',
  },
];

const BlacklistContainer = () => {
  const t = useTranslations('blacklistManagement.tabs');
  return (
   <BlacklistManagementProvider>
      <BlacklistHeader />
      <LinkTabs settingsTabs={getBlacklistTabs(t)} />
      <Outlet />
   </BlacklistManagementProvider>
  );
};

export default BlacklistContainer;
